import React from "react";
import "../index.css";

const STEPS = [
  "Location",
  "Characteristics",
  "Operating Inputs",
  "Future Potential",
  "Result",
];

function ValuationFrame({ currentStep, title, subtitle, children }) {
  return (
    <main className="form-container valuation-card">
      <section className="brand" aria-label="Skyward valuation">
        <img
          className="brand-logo-full"
          src={`${process.env.PUBLIC_URL}/skyward-logo.svg`}
          alt="Skyward Innovation"
        />
        <div>
          <p className="brand-tagline">Preliminary hotel valuation intake</p>
        </div>
      </section>

      <section className="progress" aria-label="Form progress">
        {STEPS.map((step, index) => (
          <div
            className={`progress-step ${
              index + 1 === currentStep ? "active" : ""
            }`}
            key={step}
          >
            {index + 1}. {step}
          </div>
        ))}
      </section>

      <section className="page active">
        <h1>{title}</h1>
        {subtitle && <p className="subtitle">{subtitle}</p>}
        {children}
      </section>
    </main>
  );
}

export default ValuationFrame;
